module.exports = __webpack_public_path__ + "img/tech_7.43b2a770.jpg";